import React, { useEffect, useRef, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { useApiCaller } from '../utils/ApiUtilities';
import { getGoogleAuthUrl } from '../utils/UrlUtilities';
import { constructGoogleAuthPayload } from '../utils/PayloadUtils';
import { getUserData } from '../utils/TokenUtilities';

// Shared "Sign in with Google" button for the Login and Signup screens.
// `onAuthed` is the session setter to run on success (loginState/signupState);
// both currently behave identically.
export default function GoogleAuthButton({ onAuthed, referralToken }) {
    const navigate = useNavigate();
    const CallApi = useApiCaller();

    // The GIS button renders as a fixed-pixel iframe, so it can't use Bootstrap's
    // `w-100`. Measure the wrapper (which spans the form width) and render the
    // button at that width so it matches the Login/Sign Up buttons. GIS caps
    // width at 400px, which fits the 400px-max auth forms.
    const wrapperRef = useRef(null);
    const [btnWidth, setBtnWidth] = useState(0);
    useEffect(() => {
        if (wrapperRef.current) {
            setBtnWidth(wrapperRef.current.offsetWidth);
        }
    }, []);

    const handleSuccess = async (credentialResponse) => {
        const credential = credentialResponse?.credential;
        if (!credential) return;

        const response = await CallApi({
            url: getGoogleAuthUrl(),
            method: 'POST',
            payload: constructGoogleAuthPayload(credential, referralToken),
            token: false,
        });

        if (response.success) {
            const userData = getUserData(response.data.jwt_token);
            onAuthed({
                userId: userData?.user_id,
                email: userData?.user_email,
                name: userData?.user_name,
                user_role: userData?.user_role,
                jwt_token: response.data.jwt_token,
                refresh_token: response.data.refresh_token,
            });
            navigate('/home');
        } else {
            console.error('Google Auth Error Message::', response.message);
        }
    };

    return (
        <div ref={wrapperRef} className="w-100">
            {btnWidth > 0 && (
                <GoogleLogin
                    onSuccess={handleSuccess}
                    onError={() => console.error('Google sign-in failed')}
                    width={btnWidth}
                />
            )}
        </div>
    );
}
